import React, { useState, useEffect } from "react";
import { Button, Input, message, Spin, Form } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { useSelector } from "react-redux";
import { get_downloads, update_downloads } from "../../endpoints/API";

const AppDownloads = () => {
  const [playstoreDownloads, setPlaystoreDownloads] = useState("");
  const [appstoreDownloads, setAppstoreDownloads] = useState("");
  const [loading, setLoading] = useState(false);
  const [downloadId, setDownloadId] = useState(null); 
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  // const rootUrl = `${prodTestUrl || baseUrl}/api`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await get_downloads()

        if (!response.statusText=="OK") {
          throw new Error("Failed to fetch download data.");
        }

        const data = response?.data;
        setPlaystoreDownloads(data.play_store);
        setAppstoreDownloads(data.app_store);
        setDownloadId(data.id); 
      } catch (error) {
        message.error(error?.response?.data?.error || "Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async () => {
    if (!playstoreDownloads || !appstoreDownloads) {
      message.warning("Please fill in both download counts.");
      return;
    }
    if (!downloadId) {
      message.error("No record found to update.");
      return;
    }

    setLoading(true);

    try {
      const response = await update_downloads(downloadId, playstoreDownloads, appstoreDownloads);

      if (!response.statusText=="OK") {
        throw new Error("Failed to update download data.");
      }
      message.success("Download data updated successfully.");
    } catch (error) {
      message.error(error?.response?.data?.error || "Update failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form layout="vertical" className="mt-[1rem]">
        <Form.Item label="Playstore Download">
          <Input
            className="w-[50%]"
            value={playstoreDownloads}
            onChange={(e) => setPlaystoreDownloads(e.target.value)}
            placeholder="Enter total app downloads from Play Store."
          />
        </Form.Item>
        <Form.Item label="App Store Downloads">
          <Input
            className="w-[50%]"
            value={appstoreDownloads}
            onChange={(e) => setAppstoreDownloads(e.target.value)}
            placeholder="Enter total app downloads from App Store."
          />
        </Form.Item>
        <Button type="primary" onClick={handleSubmit}>
          Update
        </Button>
      </Form>
    </Spin>
  );
};

export default AppDownloads;
